import type { TechProfileListItem } from '@/lib/types';

export function getIrataLevel(tech: TechProfileListItem): string {
  const highestLevel = (tech.certification_summary ?? []).reduce((highest, certification) => {
    const match = /^irata_([1-3])$/.exec(certification.cert_type);
    return match ? Math.max(highest, Number(match[1])) : highest;
  }, 0);

  return highestLevel > 0 ? `IRATA ${highestLevel}` : '—';
}

export function getCertStatusDisplay(tech: TechProfileListItem) {
  const certifications = tech.certification_summary ?? [];
  if (certifications.length === 0) {
    return { label: 'None', className: 'text-gray-500' };
  }
  if (certifications.some((certification) => certification.status === 'expired')) {
    return { label: 'Expired', className: 'text-red-600 font-medium' };
  }
  if (certifications.some((certification) => certification.status === 'revoked')) {
    return { label: 'Revoked', className: 'text-gray-600 font-medium' };
  }
  if (certifications.some((certification) => certification.status === 'expiring_soon')) {
    return { label: 'Expiring Soon', className: 'text-amber-600 font-medium' };
  }
  return { label: 'Valid', className: 'text-green-600' };
}
